import apiClient from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

const kycService = {
  /**
   * Soumettre les documents KYC
   * @param {FormData} formData - FormData contenant les images et numéros de référence
   * @returns {Promise<Object>}
   */
  async submitKYC(formData) {
    try {
      return await apiClient.post(API_ENDPOINTS.KYC.SUBMIT, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw new Error(handleError(error, 'kycService.submitKYC'));
    }
  },

  /**
   * Obtenir le statut KYC de l'utilisateur
   * @returns {Promise<Object>}
   */
  async getKYCStatus() {
    try {
      return await apiClient.get(API_ENDPOINTS.KYC.STATUS);
    } catch (error) {
      throw new Error(handleError(error, 'kycService.getKYCStatus'));
    }
  },

  /**
   * Valider le KYC d'un utilisateur (Admin seulement)
   * @param {string} userId - ID de l'utilisateur
   * @returns {Promise<Object>}
   */
  async verifyKYC(userId) {
    try {
      return await apiClient.patch(API_ENDPOINTS.KYC.VERIFY(userId));
    } catch (error) {
      throw new Error(handleError(error, 'kycService.verifyKYC'));
    }
  },

  /**
   * Rejeter le KYC d'un utilisateur (Admin seulement)
   * @param {string} userId - ID de l'utilisateur
   * @param {string} reason - Raison du rejet
   * @returns {Promise<Object>}
   */
  async rejectKYC(userId, reason) {
    try {
      return await apiClient.patch(API_ENDPOINTS.KYC.REJECT(userId), { reason });
    } catch (error) {
      throw new Error(handleError(error, 'kycService.rejectKYC'));
    }
  },
};

export default kycService;

